<div class="step-con-box">
    <div class="step-subject-box">
        <div class="main-txt">
            {{ "join.info.title" | translate }}
        </div>
        <div class="sub-txt">
            {{ "join.info.guideLine1" | translate }}
            <br />
            {{ "join.info.guideLine2" | translate }}
        </div>
    </div>
    <article class="sign-in-form">
        <div class="form-wrap">
            <div class="row">
                <div class="subject">
                    {{ "join.info.id" | translate }}
                </div>
                <div class="con">
                    <div class="input-box">
                        <input type="text" [(ngModel)]="joinDto.email" (keyup)="joinValidator.checkEmail(joinDto.email)" />
                    </div>
                    <div class="msg-box">
                        <div class="msg-txt type2" *ngIf="!joinValidator.isEmailExist">
                            {{ "join.info.emailNotExist" | translate }}
                        </div>
                        <div class="msg-txt type2" *ngIf="joinValidator.isEmailExist && !joinValidator.isEmailValid">
                            {{ "join.info.invalidEmail" | translate }}
                        </div>
                        <div class="info-txt">
                            <b>
                                {{ "join.info.emailGuideLine1" | translate }}
                            </b>
                            <br />
                            {{ "join.info.emailGuideLine2" | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="subject">
                    {{ "join.info.name" | translate }}
                </div>
                <div class="con">
                    <div class="input-box">
                        <input type="text" [(ngModel)]="joinDto.name" />
                    </div>
                    <div class="msg-box"></div>
                </div>
            </div>
            <div class="row">
                <div class="subject">
                    {{ "join.info.password" | translate }}
                </div>
                <div class="con">
                    <div class="input-box">
                        <input type="password" [(ngModel)]="joinDto.password" (keyup)="joinValidator.checkPassword(joinDto.password, passwordConfirm)" />
                    </div>
                    <div class="msg-box">
                        <div class="msg-txt type2" *ngIf="!joinValidator.isPasswordExist">
                            {{ "join.info.passwordNotExist" | translate }}
                        </div>
                        <div class="msg-txt type2" *ngIf="joinValidator.isPasswordExist && !joinValidator.isPasswordValid">
                            {{ "join.info.invalidPassword" | translate }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="subject">
                    {{ "join.info.passwordConfirm" | translate }}
                </div>
                <div class="con">
                    <div class="input-box">
                        <input type="password" [(ngModel)]="passwordConfirm" (keyup)="joinValidator.checkPassword(joinDto.password, passwordConfirm)" />
                    </div>
                    <div class="msg-box">
                        <div class="msg-txt type2" *ngIf="joinValidator.isPasswordExist && !joinValidator.isPasswordCorrect">
                            {{ "join.info.passwordNotMatched" | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
    <article class="sign-in-btn">
        <div class="btn-box">
            <a class="cancel-btn" (click)="cancel()">
                {{ "join.info.prevButton" | translate }}
            </a>
        </div>
        <div class="btn-box">
            <a class="primary-btn disabled" [class.disabled]="!joinValidator.isValid()" (click)="next()">
                {{ "join.info.nextButton" | translate }}
            </a>
        </div>
    </article>
</div>
